import * as jQuery from 'jquery';
import * as Masonry from 'masonry-layout';

import {
	Component,
	ComponentFactoryResolver,
	ComponentRef,
	DoCheck,
	ElementRef,
	EventEmitter,
	Injector,
	Input,
	KeyValueDiffer,
	KeyValueDiffers,
	OnDestroy,
	Output
} from '@angular/core';

import { EmbeddedComponents } from '../services/embedded-components.service';

@Component({
	selector: 'app-content-viewer',
	template: '<div></div>'
})
/**
 *
 */
export class ContentViewerComponent implements DoCheck, OnDestroy {
	@Input()
	set content(content: any) {
		this.ngOnDestroy();
		if (content) {
			this.build(content);
			this.docRendered.emit();
		}
	}
	public masonry: any;
	public debounceTimer = null;

	// tslint:disable-next-line: prefer-output-readonly
	@Output() docRendered = new EventEmitter();
	private hostElement: HTMLElement;
	private embeddedComponentFactories: Map<string, any> = new Map();
	private embeddedComponents: Array<ComponentRef<any>> = [];
	private objDiffers: Array<KeyValueDiffer<string, any>>;
	private differ;

	/**
	 *
	 * @param {ComponentFactoryResolver} componentFactoryResolver
	 * @param {ElementRef} elementRef
	 * @param {EmbeddedComponents} embeddedComponents
	 * @param {Injector} injector
	 */
	constructor(
		componentFactoryResolver: ComponentFactoryResolver,
		elementRef: ElementRef,
		embeddedComponents: EmbeddedComponents,
		private injector: Injector,
		private differs: KeyValueDiffers
	) {
		this.hostElement = elementRef.nativeElement;
		this.differ = this.differs.find(this.embeddedComponents).create();
		for (const component of embeddedComponents.components) {
			const factory = componentFactoryResolver.resolveComponentFactory(component);
			const selector = factory.selector;
			const contentPropertyName = this.selectorToContentPropertyName(selector);
			this.embeddedComponentFactories.set(selector, { contentPropertyName, factory });
		}
	}

	ngDoCheck(): void {
		this.embeddedComponents.forEach((comp, index) => {
			comp.changeDetectorRef.detectChanges();
			const objDiffer = this.objDiffers[index];
			const objChanges = objDiffer.diff(comp.instance);
			if (objChanges) {
				if (this.masonry) {
					this.masonry.layout();
				}
			}
		});
	}

	ngOnDestroy(): void {
		// destroy these components else there will be memory leaks
		this.embeddedComponents.forEach((comp) => comp.destroy());
		this.embeddedComponents.length = 0;
	}

	private build(content: any): void {
		this.hostElement.innerHTML = content || '';

		if (!content) {
			return;
		}
		this.objDiffers = new Array<KeyValueDiffer<string, any>>();
		let index = 0;
		this.embeddedComponentFactories.forEach(({ contentPropertyName, factory }, selector) => {
			const embeddedComponentElements: any = this.hostElement.querySelectorAll(selector);
			for (const element of embeddedComponentElements) {
				element[contentPropertyName] = element.innerHTML;
				const embeddedComponent = factory.create(this.injector, [], element);
				for (const attr of element.attributes) {
					embeddedComponent.instance[attr.nodeName] = attr.nodeValue;
				}
				this.objDiffers[index] = this.differs.find(embeddedComponent).create();
				index++;
				this.embeddedComponents.push(embeddedComponent);
			}
		});
		index = 0;

		if (jQuery('.bee-grid').length) {
			setTimeout(() => {
				this.masonry = new Masonry('.bee-grid', {
					columnWidth: '.grid-sizer',
					horizontalOrder: true,
					itemSelector: '.widgets',
					percentPosition: true
				});
			}, 500);
		}
	}

	private selectorToContentPropertyName(selector: string): string {
		return selector.replace(/-(.)/g, (match, $1) => $1.toUpperCase()) + 'Content';
	}
}
